import {connect} from 'react-redux';

import {changeImage} from '../../actionCreators';

import Button from './Button';

const ChangeImageButton = props => <Button {...props} />;

ChangeImageButton.defaultProps = {
    change: changeImage,
};

export const mapStateToProps = (state, {action}) => {
    const {isAnimating, isDragging} = state;
    const disabled = isAnimating || isDragging;
    const nextImage = disabled ? null : action(state);

    return {
        disabled: nextImage === null,
        nextImage,
    };
};

export default connect(mapStateToProps)(ChangeImageButton);
